export default "__VITE_ASSET__CbbkPaT8__"